const ImageWithText = ({ src }) => <img className="image-ratio" src={src} />;

export default ImageWithText;
